/**
 *
 * FulfillmentNoteDetailPage
 *
 */

import FulfillmentNoteComponent from 'components/FulfillmentNote/FulfillmentNote';
import LoadingIndicator from 'components/LoadingIndicator';
import { selectStore } from 'containers/MainLayout/selectors';
import React, { Fragment, lazy, PureComponent, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import translations from 'translations';
import { FulfillmentNote, MutationSubmitFeedbackArgs, Store } from 'types/schema';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import { bulkReOrderSubmit, closeModal, openModal, submitFeedback } from './actions';
import FulfillmentNoteDetailPageHeader from './FulfillmentNoteDetailPageHeader';
import messages from './messages';
import reducer from './reducer';
import saga from './saga';
import selectFulfillmentNoteDetailPage, { selectIsOpenModal, selectNote } from './selectors';
import { RootState } from './types';

const RatingModal = lazy(() => import('components/RatingModal'));

interface OwnProps {
  fulfillmentnotedetailpage: any;
}

interface StateProps {
  fulfillmentnotedetailpage: any;
  store: Store;
  isOpenModal: boolean;
  note: FulfillmentNote;
}

interface DispatchProps {
  onBulkReOrder: (value: any) => void;
  onOpenModal: (value: FulfillmentNote) => void;
  onCloseModal: () => void;
  onSubmitFeedback: (value: MutationSubmitFeedbackArgs['input']) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

export class FulfillmentNoteDetailPage extends PureComponent<Props> {
  private hasTrackedPageView = false;

  public componentDidUpdate(prevProps: Props) {
    const { fulfillmentnotedetailpage } = this.props;
    const prevFulfillmentNote = prevProps.fulfillmentnotedetailpage?.fulfillmentNote;
    const currentFulfillmentNote = fulfillmentnotedetailpage?.fulfillmentNote;

    if (
      !this.hasTrackedPageView &&
      currentFulfillmentNote?.fulfillmentNoteId &&
      (!prevFulfillmentNote || prevFulfillmentNote.fulfillmentNoteId !== currentFulfillmentNote.fulfillmentNoteId)
    ) {
      this.hasTrackedPageView = true;
      sendGA4Event(EventName.VIEW_DELIVERY_DETAIL_PAGE, {
        ffm_id: currentFulfillmentNote.fulfillmentNoteId,
        ffm_shortcode: currentFulfillmentNote.fulfillmentNoteShortCode,
      });
    }
  }

  public render() {
    const {
      fulfillmentnotedetailpage,
      store,
      isOpenModal,
      note,
      onSubmitFeedback,
      onCloseModal,
      onOpenModal,
      onBulkReOrder,
    } = this.props;

    return (
      <Fragment>
        <Helmet>
          <title>{`${translations(messages.header)} | Nhà Cung Cấp Kamereo`}</title>
          <meta name="description" content={`${translations(messages.header)}`} />
        </Helmet>

        <FulfillmentNoteDetailPageHeader
          onBulkReOrder={onBulkReOrder}
          fulfillmentNote={fulfillmentnotedetailpage.fulfillmentNote}
          store={store.id}
          onOpenModal={onOpenModal}
        >
          <FormattedMessage {...messages.header} />
        </FulfillmentNoteDetailPageHeader>

        <FulfillmentNoteComponent fulfillmentNote={fulfillmentnotedetailpage} />

        <Suspense fallback={<LoadingIndicator />}>
          <RatingModal isOpen={isOpenModal} onClose={onCloseModal} note={note} onSubmitFeedback={onSubmitFeedback} />
        </Suspense>
      </Fragment>
    );
  }
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
  fulfillmentnotedetailpage: selectFulfillmentNoteDetailPage(),
  store: selectStore(),
  isOpenModal: selectIsOpenModal(),
  note: selectNote(),
});

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
  return {
    onBulkReOrder: (data) => dispatch(bulkReOrderSubmit(data)),
    onOpenModal: (data) => dispatch(openModal(data)),
    onCloseModal: () => dispatch(closeModal()),
    onSubmitFeedback: (value: MutationSubmitFeedbackArgs['input']) => dispatch(submitFeedback(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withReducer = injectReducer<OwnProps>({
  key: 'fulfillmentNoteDetailPage',
  reducer: reducer,
});

const withSaga = injectSaga<OwnProps>({ key: 'fulfillmentNoteDetailPage', saga: saga });

export default compose(withReducer, withSaga, withConnect)(FulfillmentNoteDetailPage);
